import React from "react";
import { NgByline, NgBylineProps } from "./ng-byline";

export interface NgBylinePillProps extends NgBylineProps {
    className?: string;
}

export const NgBylinePill = (props: NgBylinePillProps) => {
    return (
        <div className={`inline-block lg:hidden ${props.className}`}>
            <NgByline {...props} />
        </div>
    );
};
